// An external area's wash, set on site (#510, PRICING.md "Wash"): the Wash
// tick, the Wash only switch beside it, and the wash m² worked out from the
// surfaces already measured. Wash only keeps the surfaces measured (their m²
// is what the wash is priced on) but stops them being priced. Internal areas
// have no wash.
import { areaWashArea, noGirthSurfaces, setWash, setWashOnly, type SurfacesDoc, type SurfaceType } from '@higgins/m2q-pricing';
import { formatQuantity } from './surface-format';

/** The pill on an area or a section that is washed and not painted. */
export function WashOnlyBadge({ className = 'ml-2' }: { className?: string }) {
  return <span className={`${className} inline-block shrink-0 rounded-full bg-sky-50 px-2 text-xs font-normal text-sky-800`}>Wash only</span>;
}

interface AreaWashProps {
  doc: SurfacesDoc;
  types: ReadonlyMap<string, SurfaceType>;
  onChange: (doc: SurfacesDoc) => void;
}

export function AreaWash({ doc, types, onChange }: AreaWashProps) {
  const wash = doc.wash === true;
  const noGirth = noGirthSurfaces(doc, types);
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
        <label className="flex min-h-11 items-center gap-2 text-sm font-medium text-slate-900">
          <input type="checkbox" checked={wash} onChange={(e) => onChange(setWash(doc, e.target.checked))} className="h-5 w-5 accent-orange-500" />
          Wash
        </label>
        <label className="flex min-h-11 items-center gap-2 text-sm font-medium text-slate-900">
          <input type="checkbox" role="switch" checked={doc.washOnly === true} onChange={(e) => onChange(setWashOnly(doc, e.target.checked))} className="h-5 w-5 accent-orange-500" />
          Wash only
        </label>
        {wash && (
          <span className="ml-auto text-sm tabular-nums text-slate-700">
            Wash <span className="font-medium">{formatQuantity(areaWashArea(doc, types))} m²</span>
            <span className="text-slate-500"> from the surfaces</span>
          </span>
        )}
      </div>
      {doc.washOnly && <p className="text-xs text-slate-600">No painting: the surfaces stay measured for the wash m², and aren&rsquo;t priced.</p>}
      {wash && noGirth.length > 0 && <p className="text-xs text-amber-700">No girth, so not in the wash m²: {noGirth.map((s) => s.name).join(', ')}.</p>}
    </div>
  );
}
